import { render, staticRenderFns } from "./DocumentSidebarAddButton.vue?vue&type=template&id=4adedf1b"
import script from "./DocumentSidebarAddButton.vue?vue&type=script&lang=js"
export * from "./DocumentSidebarAddButton.vue?vue&type=script&lang=js"
import style0 from "./DocumentSidebarAddButton.vue?vue&type=style&index=0&id=4adedf1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports